const environmentColours = [
  "#137cbd",
  "#d9822b",
  "#8f398f",
  "#0f9960",
] as const;

export function normalizeDevEnvironmentLabel(
  value: string | undefined,
  isDevelopment: boolean,
): string | null {
  if (!isDevelopment) return null;

  const label = value?.trim().toUpperCase();
  return label || null;
}

export function getDevEnvironmentLabel(): string | null {
  return normalizeDevEnvironmentLabel(
    import.meta.env.VITE_DEV_ENVIRONMENT_LABEL,
    import.meta.env.DEV,
  );
}

export function getDevEnvironmentColour(label: string): string {
  const hash = [...label].reduce(
    (value, character) => value + character.charCodeAt(0),
    0,
  );

  return (
    environmentColours[(hash - 1) % environmentColours.length] ??
    environmentColours[0]
  );
}
